
// src/theme/welcomeStyles.js - Simplified with 30 themes
export const WELCOME_STYLES = {
  // Update all WELCOME_STYLES with backdropColor and sporty fonts:
STYLE_1: {
  id: 1,
  name: "Carbon Fiber",
  colors: {
    background: "#131313",
    text: "#f0f0f0",
    accent: "#00c6ff",
    accentGradient: "linear-gradient(45deg, #00c6ff, #0072ff)",
    surface: "rgba(0, 198, 255, 0.1)",
    backdropColor: "rgba(0, 100, 150, 0.85)"
  },
  fonts: {
    heading: "'Syne', sans-serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_2: {
  id: 2,
  name: "Midnight Jade",
  colors: {
    background: "#0a1c1a",
    text: "#ecfdf5",
    accent: "#5eead4",
    accentGradient: "linear-gradient(45deg, #5eead4, #2dd4bf, #14b8a6)",
    surface: "rgba(94, 234, 212, 0.15)",
    backdropColor: "rgba(10, 60, 55, 0.88)"
  },
  fonts: {
    heading: "'Josefin Sans', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_3: {
  id: 3,
  name: "Royal Gold",
  colors: {
    background: "#0A0A0A",
    text: "#FFFFFF",
    accent: "#D4AF37",
    accentGradient: "linear-gradient(45deg, #D4AF37, #AA8C2C)",
    surface: "rgba(212, 175, 55, 0.15)",
    backdropColor: "rgba(80, 70, 30, 0.90)"
  },
  fonts: {
    heading: "'Cinzel', serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_4: {
  id: 4,
  name: "Neon Pulse",
  colors: {
    background: "#050B15",
    text: "#E2E8F0",
    accent: "#42D392",
    accentGradient: "linear-gradient(45deg, #42D392, #647EC9)",
    surface: "rgba(66, 211, 146, 0.15)",
    backdropColor: "rgba(20, 40, 60, 0.87)"
  },
  fonts: {
    heading: "'Chakra Petch', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_5: {
  id: 5,
  name: "Sunset Horizon",
  colors: {
    background: "#16213E",
    text: "#F1F1F1",
    accent: "#E94560",
    accentGradient: "linear-gradient(45deg, #E94560, #ff6b8b)",
    surface: "rgba(233, 69, 96, 0.2)",
    backdropColor: "rgba(40, 60, 80, 0.89)"
  },
  fonts: {
    heading: "'Raleway', sans-serif",
    body: "'Josefin Sans', sans-serif"
  }
},
STYLE_6: {
  id: 6,
  name: "Emerald Forest",
  colors: {
    background: "#111927",
    text: "#ECFDF5",
    accent: "#10B981",
    accentGradient: "linear-gradient(45deg, #10B981, #059669)",
    surface: "rgba(16, 185, 129, 0.2)",
    backdropColor: "rgba(20, 50, 40, 0.88)"
  },
  fonts: {
    heading: "'Montserrat', sans-serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_7: {
  id: 7,
  name: "Trap Graphite",
  colors: {
    background: "#1a1d23",
    text: "#e8edf3",
    accent: "#64b5f6",
    accentGradient: "linear-gradient(45deg, #64b5f6, #42a5f5, #2196f3)",
    surface: "rgba(100, 181, 246, 0.12)",
    backdropColor: "rgba(30, 40, 50, 0.90)"
  },
  fonts: {
    heading: "'Barlow Condensed', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_8: {
  id: 8,
  name: "Obsidian Volcanic",
  colors: {
    background: "#121212",
    text: "#FAF9F6",
    accent: "#F04438",
    accentGradient: "linear-gradient(45deg, #F04438, #C01048)",
    surface: "rgba(240, 68, 56, 0.2)",
    backdropColor: "rgba(60, 20, 20, 0.88)"
  },
  fonts: {
    heading: "'Cormorant Garamond', serif",
    body: "'Libre Franklin', sans-serif"
  }
},
STYLE_9: {
  id: 9,
  name: "Arctic Frost",
  colors: {
    background: "#111827",
    text: "#F9FAFB",
    accent: "#38BDF8",
    accentGradient: "linear-gradient(45deg, #38BDF8, #0EA5E9)",
    surface: "rgba(56, 189, 248, 0.2)",
    backdropColor: "rgba(30, 50, 70, 0.87)"
  },
  fonts: {
    heading: "'Iceland', cursive",
    body: "'Inter', sans-serif"
  }
},
STYLE_10: {
  id: 10,
  name: "Ethereal Nebula",
  colors: {
    background: "#0F0F1A",
    text: "#F5F5F5",
    accent: "#D946EF",
    accentGradient: "linear-gradient(45deg, #D946EF, #9333EA)",
    surface: "rgba(217, 70, 239, 0.2)",
    backdropColor: "rgba(40, 20, 60, 0.89)"
  },
  fonts: {
    heading: "'Oxanium', sans-serif",
    body: "'Exo 2', sans-serif"
  }
},
STYLE_11: {
  id: 11,
  name: "Miami Sunset",
  colors: {
    background: "#1a0a2e",
    text: "#FFFFFF",
    accent: "#FF6EC7",
    accentGradient: "linear-gradient(135deg, #FF6EC7, #FFA500, #FF1493)",
    surface: "rgba(255, 110, 199, 0.15)",
    backdropColor: "rgba(50, 30, 70, 0.90)",
    headerBg: "rgba(26, 10, 46, 0.95)",
    tabActiveBg: "rgba(255, 110, 199, 0.25)",
    tabBorder: "#FF6EC7"
  },
  fonts: {
    heading: "'Audiowide', sans-serif",
    body: "'Comfortaa', cursive"
  }
},
STYLE_12: {
  id: 12,
  name: "Highland Coffee",
  colors: {
    background: "#1A0F0A",
    text: "#F5E6D3",
    accent: "#D4AF37",
    accentGradient: "linear-gradient(135deg, #D4AF37, #B8860B, #CD853F)",
    surface: "rgba(212, 175, 55, 0.12)",
    backdropColor: "rgba(60, 40, 25, 0.88)",
    headerBg: "rgba(26, 15, 10, 0.95)",
    tabActiveBg: "rgba(212, 175, 55, 0.2)",
    tabBorder: "#D4AF37"
  },
  fonts: {
    heading: "'Playfair Display', serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_13: {
  id: 13,
  name: "Nordic Midnight",
  colors: {
    background: "#1B2431",
    text: "#E8F4F8",
    accent: "#4ECDC4",
    accentGradient: "linear-gradient(135deg, #4ECDC4, #44A08D, #093637)",
    surface: "rgba(78, 205, 196, 0.15)",
    backdropColor: "rgba(40, 60, 80, 0.87)",
    headerBg: "rgba(27, 36, 49, 0.95)",
    tabActiveBg: "rgba(78, 205, 196, 0.25)",
    tabBorder: "#4ECDC4"
  },
  fonts: {
    heading: "'Raleway', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_14: {
  id: 14,
  name: "Honey Gold",
  colors: {
    background: "#1a1409",
    text: "#fefce8",
    accent: "#eab308",
    accentGradient: "linear-gradient(45deg, #eab308, #ca8a04, #a16207)",
    surface: "rgba(234, 179, 8, 0.18)",
    backdropColor: "rgba(70, 55, 20, 0.88)"
  },
  fonts: {
    heading: "'Cinzel', serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_15: {
  id: 15,
  name: "Ocean Depth",
  colors: {
    background: "#0d1b2a",
    text: "#e0f2fe",
    accent: "#0ea5e9",
    accentGradient: "linear-gradient(45deg, #0ea5e9, #06b6d4, #0891b2)",
    surface: "rgba(14, 165, 233, 0.15)",
    backdropColor: "rgba(20, 50, 80, 0.87)"
  },
  fonts: {
    heading: "'Questrial', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_16: {
  id: 16,
  name: "Tech Entrepreneur",
  colors: {
    background: "#0A0E27",
    text: "#E8E8E8",
    accent: "#00D2FF",
    accentGradient: "linear-gradient(45deg, #00D2FF, #3A7BD5, #6C5CE7)",
    surface: "rgba(0, 210, 255, 0.2)",
    backdropColor: "rgba(20, 30, 60, 0.89)"
  },
  fonts: {
    heading: "'Space Grotesk', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_17: {
  id: 17,
  name: "Velvet Lounge",
  colors: {
    background: "#1a0e1f",
    text: "#fce7f3",
    accent: "#c026d3",
    accentGradient: "linear-gradient(45deg, #c026d3, #a21caf, #86198f)",
    surface: "rgba(192, 38, 211, 0.15)",
    backdropColor: "rgba(50, 30, 60, 0.88)"
  },
  fonts: {
    heading: "'Cormorant Garamond', serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_18: {
  id: 18,
  name: "Royal Elegance",
  colors: {
    background: "#1A1A2E",
    text: "#F8F8FF",
    accent: "#9370DB",
    accentGradient: "linear-gradient(45deg, #9370DB, #BA55D3)",
    surface: "rgba(147, 112, 219, 0.2)",
    backdropColor: "rgba(50, 40, 70, 0.89)"
  },
  fonts: {
    heading: "'Cinzel Decorative', cursive",
    body: "'Roboto', sans-serif"
  }
},
STYLE_19: {
  id: 19,
  name: "Bronze Business",
  colors: {
    background: "#1a1410",
    text: "#f5f1ed",
    accent: "#c17d3a",
    accentGradient: "linear-gradient(45deg, #c17d3a, #a86b2e, #8f5924)",
    surface: "rgba(193, 125, 58, 0.15)",
    backdropColor: "rgba(70, 50, 30, 0.87)",
    headerBg: "rgba(26, 20, 16, 0.95)",
    tabActiveBg: "rgba(193, 125, 58, 0.2)",
    tabBorder: "#c17d3a"
  },
  fonts: {
    heading: "'Libre Franklin', sans-serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_20: {
  id: 20,
  name: "Waving Flag",
  colors: {
    background: "#1C1C1E",
    text: "#F2F2F7",
    accent: "#FF375F",
    accentGradient: "linear-gradient(45deg, #FF375F, #FF9500, #30D158)",
    surface: "rgba(255, 55, 95, 0.25)",
    backdropColor: "rgba(60, 40, 50, 0.88)"
  },
  fonts: {
    heading: "'Bebas Neue', sans-serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_21: {
  id: 21,
  name: "Crypto Millionaire",
  colors: {
    background: "#0B0E11",
    text: "#FFFFFF",
    accent: "#F7931A",
    accentGradient: "linear-gradient(45deg, #F7931A, #50AF95, #6C5CE7)",
    surface: "rgba(247, 147, 26, 0.2)",
    backdropColor: "rgba(30, 40, 50, 0.89)"
  },
  fonts: {
    heading: "'Lucida Console', 'Courier New', monospace",
    body: "'Lucida Sans Unicode', 'Lucida Grande', sans-serif"
  }
},
STYLE_22: {
  id: 22,
  name: "Tropical Sunset",
  colors: {
    background: "#1a0f0a",
    text: "#fff7ed",
    accent: "#fb7185",
    accentGradient: "linear-gradient(135deg, #fb7185, #f97316, #facc15)",
    surface: "rgba(251, 113, 133, 0.2)",
    backdropColor: "rgba(60, 40, 30, 0.88)"
  },
  fonts: {
    heading: "'Lora', serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_23: {
  id: 23,
  name: "Copper Classic",
  colors: {
    background: "#1c1410",
    text: "#faf8f5",
    accent: "#d97706",
    accentGradient: "linear-gradient(45deg, #d97706, #f59e0b, #fbbf24)",
    surface: "rgba(217, 119, 6, 0.15)",
    backdropColor: "rgba(70, 50, 25, 0.87)"
  },
  fonts: {
    heading: "'Josefin Slab', serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_24: {
  id: 24,
  name: "Solar Drift",
  colors: {
    background: "#0c0a00",
    text: "#FFF8E7",
    accent: "#FFAB00",
    accentGradient: "linear-gradient(135deg, #FFAB00, #FF6D00, #E040FB, #651FFF)",
    surface: "rgba(255, 171, 0, 0.15)",
    backdropColor: "rgba(28, 20, 5, 0.90)",
    headerBg: "rgba(12, 10, 0, 0.96)",
    tabActiveBg: "rgba(255, 171, 0, 0.22)",
    tabBorder: "#FFAB00"
  },
  fonts: {
    heading: "'Syne', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_25: {
  id: 25,
  name: "Fashion Forward",
  colors: {
    background: "#1A1A1A",
    text: "#FAFAFA",
    accent: "#E91E63",
    accentGradient: "linear-gradient(45deg, #E91E63, #9C27B0, #673AB7)",
    surface: "rgba(233, 30, 99, 0.25)",
    backdropColor: "rgba(50, 30, 60, 0.88)"
  },
  fonts: {
    heading: "'Playfair Display', serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_26: {
  id: 26,
  name: "Cyberpunk 2077",
  colors: {
    background: "#0F0F23",
    text: "#00FFFF",
    accent: "#cece0f",
    accentGradient: "linear-gradient(45deg, #fcfc04, #FF00FF)",
    surface: "rgba(255, 255, 0, 0.2)",
    backdropColor: "rgba(30, 20, 50, 0.90)"
  },
  fonts: {
    heading: "'Share Tech Mono', monospace",
    body: "'Rajdhani', sans-serif"
  }
},
STYLE_27: {
  id: 27,
  name: "Cherry Blossom",
  colors: {
    background: "#1f0a1a",
    text: "#fdf2f8",
    accent: "#db2777",
    accentGradient: "linear-gradient(45deg, #ec4899, #db2777, #be185d)",
    surface: "rgba(249, 168, 212, 0.18)",
    backdropColor: "rgba(60, 30, 50, 0.87)"
  },
  fonts: {
    heading: "'Quicksand', sans-serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_28: {
  id: 28,
  name: "Arctic Aurora",
  colors: {
    background: "#0a1628",
    text: "#f0f9ff",
    accent: "#7dd3fc",
    accentGradient: "linear-gradient(135deg, #7dd3fc, #38bdf8, #0ea5e9)",
    surface: "rgba(125, 211, 252, 0.18)",
    backdropColor: "rgba(20, 50, 70, 0.87)"
  },
  fonts: {
    heading: "'Jura', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_29: {
  id: 29,
  name: "Afrofuturist Vision",
  colors: {
    background: "#0a0515",
    text: "#F0E6FF",
    accent: "#FF6B9D",
    accentGradient: "linear-gradient(135deg, #FF6B9D, #C74BD4, #8B5CF6, #FFD700)",
    surface: "rgba(255, 107, 157, 0.15)",
    backdropColor: "rgba(30, 20, 50, 0.89)",
    headerBg: "rgba(10, 5, 21, 0.95)",
    tabActiveBg: "rgba(255, 107, 157, 0.25)",
    tabBorder: "#FF6B9D"
  },
  fonts: {
    heading: "'Syne', sans-serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_30: {
  id: 30,
  name: "Space Explorer",
  colors: {
    background: "#000000",
    text: "#FFFFFF",
    accent: "#1E90FF",
    accentGradient: "linear-gradient(45deg, #1E90FF, #8A2BE2)",
    surface: "rgba(30, 144, 255, 0.2)",
    backdropColor: "rgba(20, 30, 60, 0.88)"
  },
  fonts: {
    heading: "'Turret Road', cursive",
    body: "'Exo 2', sans-serif"
  }
}, 
  STYLE_31: {
  id: 31,
  name: "Minted Glance",
  colors: {
    background: "#0f1b15",
    text: "#ecfdf5",
    accent: "#34d399",
    accentGradient: "linear-gradient(45deg, #34d399, #10b981, #059669)",
    surface: "rgba(52, 211, 153, 0.12)"
  },
  fonts: {
    heading: "'Josefin Sans', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_32: {
  id: 32,
  name: "Rose Quartz",
  colors: {
    background: "#1f1419",
    text: "#fdf2f8",
    accent: "#f472b6",
    accentGradient: "linear-gradient(45deg, #f472b6, #ec4899, #db2777)",
    surface: "rgba(244, 114, 182, 0.15)"
  },
  fonts: {
    heading: "'Comfortaa', cursive",
    body: "'Inter', sans-serif"
  }
},
STYLE_33: {
  id: 33,
  name: "Teal Blue",
  colors: {
    background: "#0d1a1a",
    text: "#f0fdfa",
    accent: "#14b8a6",
    accentGradient: "linear-gradient(45deg, #14b8a6, #0d9488, #0f766e)",
    surface: "rgba(20, 184, 166, 0.15)"
  },
  fonts: {
    heading: "'Montserrat', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_34: {
  id: 34,
  name: "Lavender Dusk",
  colors: {
    background: "#1a1625",
    text: "#f5f3ff",
    accent: "#a78bfa",
    accentGradient: "linear-gradient(45deg, #a78bfa, #8b5cf6, #7c3aed)",
    surface: "rgba(167, 139, 250, 0.15)"
  },
  fonts: {
    heading: "'Lora', serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_35: {
  id: 35,
  name: "Cosmic Nebula",
  colors: {
    background: "#0a0015",
    text: "#e8e8ff",
    accent: "#a78bfa",
    accentGradient: "linear-gradient(135deg, #a78bfa, #ec4899, #06b6d4, #8b5cf6)",
    surface: "rgba(167, 139, 250, 0.25)"
  },
  fonts: {
    heading: "'Space Grotesk', sans-serif",
    body: "'Exo 2', sans-serif"
  }
},
STYLE_36: {
  id: 36,
  name: "Coral Breeze",
  colors: {
    background: "#1f1410",
    text: "#fff7ed",
    accent: "#fb923c",
    accentGradient: "linear-gradient(45deg, #fb923c, #f97316, #ea580c)",
    surface: "rgba(251, 146, 60, 0.15)"
  },
  fonts: {
    heading: "'Comfortaa', cursive",
    body: "'Inter', sans-serif"
  }
},
STYLE_37: {
  id: 37,
  name: "Obsidian Pulse",
  colors: {
    background: "#08060f",
    text: "#EDE8FF",
    accent: "#A78BFA",
    accentGradient: "linear-gradient(135deg, #A78BFA, #7C3AED, #EC4899, #F59E0B)",
    surface: "rgba(167, 139, 250, 0.14)",
    backdropColor: "rgba(15, 10, 30, 0.92)",
    headerBg: "rgba(8, 6, 15, 0.97)",
    tabActiveBg: "rgba(167, 139, 250, 0.22)",
    tabBorder: "#A78BFA"
  },
  fonts: {
    heading: "'Syne', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_38: {
  id: 38,
  name: "Lime Modern",
  colors: {
    background: "#141a0f",
    text: "#f7fee7",
    accent: "#84cc16",
    accentGradient: "linear-gradient(45deg, #84cc16, #65a30d, #4d7c0f)",
    surface: "rgba(132, 204, 22, 0.15)"
  },
  fonts: {
    heading: "'Nunito', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_39: {
  id: 39,
  name: "Ruby Executive",
  colors: {
    background: "#1a0f0f",
    text: "#fef2f2",
    accent: "#ef4444",
    accentGradient: "linear-gradient(45deg, #ef4444, #dc2626, #b91c1c)",
    surface: "rgba(239, 68, 68, 0.15)"
  },
  fonts: {
    heading: "'Libre Baskerville', serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_40: {
  id: 40,
  name: "Pewter Modern",
  colors: {
    background: "#1a1a1f",
    text: "#f8fafc",
    accent: "#94a3b8",
    accentGradient: "linear-gradient(45deg, #3484f3ff, #0169fbff, #0c4ba4ff)",
    surface: "rgba(148, 163, 184, 0.15)"
  },
  fonts: {
    heading: "'DM Sans', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_41: {
  id: 41,
  name: "Cyan Wave",
  colors: {
    background: "#0a1a1f",
    text: "#ecfeff",
    accent: "#22d3ee",
    accentGradient: "linear-gradient(45deg, #22d3ee, #06b6d4, #0891b2)",
    surface: "rgba(34, 211, 238, 0.15)"
  },
  fonts: {
    heading: "'Barlow Condensed', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_42: {
  id: 42,
  name: "Amber Glow",
  colors: {
    background: "#1f1a0a",
    text: "#fffbeb",
    accent: "#fbbf24",
    accentGradient: "linear-gradient(45deg, #fbbf24, #f59e0b, #d97706)",
    surface: "rgba(251, 191, 36, 0.15)"
  },
  fonts: {
    heading: "'Cormorant Garamond', serif",
    body: "'Libre Franklin', sans-serif"
  }
},
STYLE_43: {
  id: 43,
  name: "Violet Dream",
  colors: {
    background: "#1a141f",
    text: "#faf5ff",
    accent: "#c084fc",
    accentGradient: "linear-gradient(45deg, #c084fc, #a855f7, #9333ea)",
    surface: "rgba(192, 132, 252, 0.15)"
  },
  fonts: {
    heading: "'Cormorant Garamond', serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_44: {
  id: 44,
  name: "Forest Executive",
  colors: {
    background: "#0f1a14",
    text: "#f0fdf4",
    accent: "#22c55e",
    accentGradient: "linear-gradient(45deg, #22c55e, #16a34a, #15803d)",
    surface: "rgba(34, 197, 94, 0.15)"
  },
  fonts: {
    heading: "'Plus Jakarta Sans', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_45: {
  id: 45,
  name: "Gray Seal",
  colors: {
    background: "#0f1419",
    text: "#f1f5f9",
    accent: "#64748b",
    accentGradient: "linear-gradient(45deg, #64748b, #475569, #334155)",
    surface: "rgba(100, 116, 139, 0.15)"
  },
  fonts: {
    heading: "'Questrial', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_46: {
  id: 46,
  name: "Fuchsia Edge",
  colors: {
    background: "#1a0e1f",
    text: "#f5e9f7",
    accent: "#c084fc",
    accentGradient: "linear-gradient(45deg, #c084fc, #a855f7, #9333ea)",
    surface: "rgba(192, 132, 252, 0.15)"
  },
  fonts: {
    heading: "'Cormorant Garamond', serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_47: {
  id: 47,
  name: "Steel Blue",
  colors: {
    background: "#141419",
    text: "#fafafa",
    accent: "#71717a",
    accentGradient: "linear-gradient(45deg, #71717a, #52525b, #3f3f46)",
    surface: "rgba(113, 113, 122, 0.15)"
  },
  fonts: {
    heading: "'Chakra Petch', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_48: {
  id: 48,
  name: "Emerald City",
  colors: {
    background: "#0a1f1a",
    text: "#ecfdf5",
    accent: "#10b981",
    accentGradient: "linear-gradient(45deg, #10b981, #059669, #047857)",
    surface: "rgba(16, 185, 129, 0.15)"
  },
  fonts: {
    heading: "'Quicksand', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_49: {
  id: 49,
  name: "Peach Modern",
  colors: {
    background: "#1f140a",
    text: "#fff7ed",
    accent: "#fb923c",
    accentGradient: "linear-gradient(45deg, #fb923c, #f97316, #ea580c)",
    surface: "rgba(251, 146, 60, 0.15)"
  },
  fonts: {
    heading: "'Quicksand', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_50: {
  id: 50,
  name: "Indigo Trap",
  colors: {
    background: "#14141f",
    text: "#eef2ff",
    accent: "#5b52e8",
    accentGradient: "linear-gradient(45deg, #6366f1, #5b52e8, #4338ca)",
    surface: "rgba(99, 102, 241, 0.15)"
  },
  fonts: {
    heading: "'Barlow Condensed', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_51: {
  id: 51,
  name: "Stardust Galaxy",
  colors: {
    background: "#000510",
    text: "#ffffff",
    accent: "#4fd1c5",
    accentGradient: "linear-gradient(135deg, #4fd1c5, #667eea, #f093fb, #4facfe)",
    surface: "rgba(79, 209, 197, 0.2)"
  },
  fonts: {
    heading: "'Orbitron', sans-serif",
    body: "'Rajdhani', sans-serif"
  }
},
STYLE_52: {
  id: 52,
  name: "Aqua Blue",
  colors: {
    background: "#0a1f1f",
    text: "#f0fdfa",
    accent: "#2dd4bf",
    accentGradient: "linear-gradient(45deg, #2dd4bf, #14b8a6, #0d9488)",
    surface: "rgba(45, 212, 191, 0.15)"
  },
  fonts: {
    heading: "'Josefin Sans', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_53: {
  id: 53,
  name: "Sunset Party",
  colors: {
    background: "#1f1410",
    text: "#fff7ed",
    accent: "#f97316",
    accentGradient: "linear-gradient(45deg, #f97316, #ea580c, #c2410c)",
    surface: "rgba(249, 115, 22, 0.15)"
  },
  fonts: {
    heading: "'Syne', sans-serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_54: {
  id: 54,
  name: "Urban Spray",
  colors: {
    background: "#1a0808",
    text: "#ffffff",
    accent: "#ff3864",
    accentGradient: "linear-gradient(135deg, #ff3864, #8b00ff, #00e5ff, #ffeb3b)",
    surface: "rgba(255, 56, 100, 0.25)"
  },
  fonts: {
    heading: "'Anton', sans-serif",
    body: "'Exo 2', sans-serif"
  }
},
STYLE_55: {
  id: 55,
  name: "Sapphire Executive",
  colors: {
    background: "#0a0f1f",
    text: "#eff6ff",
    accent: "#3b82f6",
    accentGradient: "linear-gradient(45deg, #3b82f6, #2563eb, #1d4ed8)",
    surface: "rgba(59, 130, 246, 0.15)"
  },
  fonts: {
    heading: "'Cormorant Garamond', serif",
    body: "'Libre Franklin', sans-serif"
  }
},
STYLE_56: {
  id: 56,
  name: "Mauve Mystic",
  colors: {
    background: "#1a141a",
    text: "#faf5ff",
    accent: "#d8b4fe",
    accentGradient: "linear-gradient(45deg, #d8b4fe, #c084fc, #a855f7)",
    surface: "rgba(216, 180, 254, 0.15)"
  },
  fonts: {
    heading: "'Raleway', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_57: {
  id: 57,
  name: "Forrest Green",
  colors: {
    background: "#141a0f",
    text: "#f7fee7",
    accent: "#65a30d",
    accentGradient: "linear-gradient(45deg, #65a30d, #4d7c0f, #3f6212)",
    surface: "rgba(101, 163, 13, 0.15)"
  },
  fonts: {
    heading: "'Raleway', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_58: {
  id: 58,
  name: "Crimson Edge",
  colors: {
    background: "#1f0a0a",
    text: "#fef2f2",
    accent: "#dc2626",
    accentGradient: "linear-gradient(45deg, #dc2626, #b91c1c, #991b1b)",
    surface: "rgba(220, 38, 38, 0.15)"
  },
  fonts: {
    heading: "'Oswald', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_59: {
  id: 59,
  name: "Azure Blue",
  colors: {
    background: "#0a1419",
    text: "#f0f9ff",
    accent: "#0284c7",
    accentGradient: "linear-gradient(45deg, #0284c7, #0369a1, #075985)",
    surface: "rgba(2, 132, 199, 0.15)"
  },
  fonts: {
    heading: "'Chakra Petch', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_61: {
  id: 61,
  name: "Platinum Executive",
  colors: {
    background: "#0a0d12",
    text: "#f8fafc",
    accent: "#64748b",
    accentGradient: "linear-gradient(45deg, #94a3b8, #64748b, #475569)",
    surface: "rgba(226, 232, 240, 0.12)",
    backdropColor: "rgba(30, 40, 50, 0.88)"
  },
  fonts: {
    heading: "'Michroma', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_62: {
  id: 62,
  name: "Champagne Luxury",
  colors: {
    background: "#1a1610",
    text: "#fefce8",
    accent: "#fef3c7",
    accentGradient: "linear-gradient(45deg, #fef3c7, #fde68a, #fcd34d)",
    surface: "rgba(254, 243, 199, 0.15)",
    backdropColor: "rgba(70, 60, 30, 0.87)"
  },
  fonts: {
    heading: "'Cinzel', serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_63: {
  id: 63,
  name: "Midnight Sapphire",
  colors: {
    background: "#070d1a",
    text: "#dbeafe",
    accent: "#3b82f6",
    accentGradient: "linear-gradient(45deg, #3b82f6, #2563eb, #1e40af)",
    surface: "rgba(59, 130, 246, 0.15)",
    backdropColor: "rgba(20, 35, 60, 0.89)"
  },
  fonts: {
    heading: "'Barlow Condensed', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_64: {
  id: 64,
  name: "Rose Gold Elegance",
  colors: {
    background: "#1a0f14",
    text: "#fff1f2",
    accent: "#fda4af",
    accentGradient: "linear-gradient(45deg, #fda4af, #fb7185, #f43f5e)",
    surface: "rgba(253, 164, 175, 0.18)",
    backdropColor: "rgba(60, 35, 45, 0.88)"
  },
  fonts: {
    heading: "'Cormorant Garamond', serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_65: {
  id: 65,
  name: "Deep Ocean",
  colors: {
    background: "#051219",
    text: "#cffafe",
    accent: "#06b6d4",
    accentGradient: "linear-gradient(45deg, #06b6d4, #0891b2, #0e7490)",
    surface: "rgba(6, 182, 212, 0.15)",
    backdropColor: "rgba(15, 45, 65, 0.87)"
  },
  fonts: {
    heading: "'Iceland', cursive",
    body: "'Inter', sans-serif"
  }
},
STYLE_66: {
  id: 66,
  name: "Sunset Amber",
  colors: {
    background: "#1a1205",
    text: "#fef3c7",
    accent: "#f59e0b",
    accentGradient: "linear-gradient(135deg, #f59e0b, #d97706, #b45309)",
    surface: "rgba(245, 158, 11, 0.18)",
    backdropColor: "rgba(70, 50, 20, 0.88)"
  },
  fonts: {
    heading: "'Lora', serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_67: {
  id: 67,
  name: "Grape Soda",
  colors: {
    background: "#14091a",
    text: "#fae8ff",
    accent: "#e879f9",
    accentGradient: "linear-gradient(45deg, #e879f9, #d946ef, #c026d3)",
    surface: "rgba(232, 121, 249, 0.2)",
    backdropColor: "rgba(50, 30, 60, 0.89)"
  },
  fonts: {
    heading: "'Syne', sans-serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_68: {
  id: 68,
  name: "Mint Fresh",
  colors: {
    background: "#0a1a1a",
    text: "#ccfbf1",
    accent: "#5eead4",
    accentGradient: "linear-gradient(45deg, #5eead4, #2dd4bf, #14b8a6)",
    surface: "rgba(94, 234, 212, 0.15)",
    backdropColor: "rgba(20, 55, 55, 0.88)"
  },
  fonts: {
    heading: "'Josefin Sans', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_69: {
  id: 69,
  name: "Jade Cipher",
  colors: {
    background: "#020d09",
    text: "#E0FFF4",
    accent: "#00E5A0",
    accentGradient: "linear-gradient(135deg, #00E5A0, #00BCD4, #3D5AFE, #AA00FF)",
    surface: "rgba(0, 229, 160, 0.13)",
    backdropColor: "rgba(5, 25, 18, 0.91)",
    headerBg: "rgba(2, 13, 9, 0.96)",
    tabActiveBg: "rgba(0, 229, 160, 0.20)",
    tabBorder: "#00E5A0"
  },
  fonts: {
    heading: "'Syne', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_70: {
  id: 70,
  name: "Arctic Ice",
  colors: {
    background: "#0a1419",
    text: "#e0f2fe",
    accent: "#0284c7",
    accentGradient: "linear-gradient(45deg, #38bdf8, #0284c7, #0369a1)",
    surface: "rgba(125, 211, 252, 0.15)",
    backdropColor: "rgba(20, 50, 70, 0.88)"
  },
  fonts: {
    heading: "'Iceland', cursive",
    body: "'Inter', sans-serif"
  }
},
STYLE_71: {
  id: 71,
  name: "Moss Garden",
  colors: {
    background: "#0d1410",
    text: "#f0fdf4",
    accent: "#86efac",
    accentGradient: "linear-gradient(45deg, #86efac, #4ade80, #22c55e)",
    surface: "rgba(134, 239, 172, 0.12)",
    backdropColor: "rgba(25, 50, 35, 0.87)"
  },
  fonts: {
    heading: "'Nunito', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_72: {
  id: 72,
  name: "Terracotta Earth",
  colors: {
    background: "#1a1008",
    text: "#fff7ed",
    accent: "#fb923c",
    accentGradient: "linear-gradient(135deg, #fb923c, #f97316, #c2410c)",
    surface: "rgba(251, 146, 60, 0.18)",
    backdropColor: "rgba(70, 45, 25, 0.88)"
  },
  fonts: {
    heading: "'DM Sans', sans-serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_73: {
  id: 73,
  name: "Lavender Fields",
  colors: {
    background: "#12091a",
    text: "#ede9fe",
    accent: "#a78bfa",
    accentGradient: "linear-gradient(45deg, #a78bfa, #8b5cf6, #7c3aed)",
    surface: "rgba(167, 139, 250, 0.18)",
    backdropColor: "rgba(45, 30, 60, 0.89)"
  },
  fonts: {
    heading: "'Lora', serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_74: {
  id: 74,
  name: "Sunset Peach",
  colors: {
    background: "#1a0f0a",
    text: "#ffedd5",
    accent: "#fdba74",
    accentGradient: "linear-gradient(45deg, #fdba74, #fb923c, #f97316)",
    surface: "rgba(253, 186, 116, 0.15)",
    backdropColor: "rgba(65, 45, 30, 0.87)"
  },
  fonts: {
    heading: "'Cinzel', serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_75: {
  id: 75,
  name: "Deep Forest",
  colors: {
    background: "#0a140f",
    text: "#d1fae5",
    accent: "#34d399",
    accentGradient: "linear-gradient(45deg, #34d399, #10b981, #059669)",
    surface: "rgba(52, 211, 153, 0.15)",
    backdropColor: "rgba(20, 50, 35, 0.88)"
  },
  fonts: {
    heading: "'Raleway', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_76: {
  id: 76,
  name: "Ruby Glow",
  colors: {
    background: "#1a0808",
    text: "#fee2e2",
    accent: "#f87171",
    accentGradient: "linear-gradient(45deg, #f87171, #ef4444, #dc2626)",
    surface: "rgba(248, 113, 113, 0.18)",
    backdropColor: "rgba(60, 25, 25, 0.88)"
  },
  fonts: {
    heading: "'Cinzel', serif",
    body: "'Lora', serif"
  }
},
STYLE_77: {
  id: 77,
  name: "Sky Dream",
  colors: {
    background: "#0a1219",
    text: "#dbeafe",
    accent: "#60a5fa",
    accentGradient: "linear-gradient(45deg, #60a5fa, #3b82f6, #2563eb)",
    surface: "rgba(96, 165, 250, 0.15)",
    backdropColor: "rgba(20, 45, 70, 0.87)"
  },
  fonts: {
    heading: "'Josefin Sans', sans-serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_78: {
  id: 78,
  name: "Honey Glow",
  colors: {
    background: "#1a1405",
    text: "#fef9c3",
    accent: "#fde047",
    accentGradient: "linear-gradient(45deg, #fde047, #facc15, #eab308)",
    surface: "rgba(253, 224, 71, 0.15)",
    backdropColor: "rgba(70, 55, 20, 0.88)"
  },
  fonts: {
    heading: "'Quicksand', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_79: {
  id: 79,
  name: "Orchid Night",
  colors: {
    background: "#140a1a",
    text: "#f5d0fe",
    accent: "#e879f9",
    accentGradient: "linear-gradient(45deg, #e879f9, #d946ef, #a855f7)",
    surface: "rgba(232, 121, 249, 0.2)",
    backdropColor: "rgba(50, 30, 60, 0.89)"
  },
  fonts: {
    heading: "'Josefin Sans', sans-serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_80: {
  id: 80,
  name: "Turquoise Wave",
  colors: {
    background: "#0a1a1a",
    text: "#99f6e4",
    accent: "#2dd4bf",
    accentGradient: "linear-gradient(45deg, #2dd4bf, #14b8a6, #0d9488)",
    surface: "rgba(45, 212, 191, 0.15)",
    backdropColor: "rgba(20, 55, 55, 0.88)"
  },
  fonts: {
    heading: "'Barlow Condensed', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_81: {
  id: 81,
  name: "Electric Lime",
  colors: {
    background: "#0f1a05",
    text: "#f7fee7",
    accent: "#a3e635",
    accentGradient: "linear-gradient(45deg, #a3e635, #84cc16, #65a30d)",
    surface: "rgba(163, 230, 53, 0.18)",
    backdropColor: "rgba(35, 55, 20, 0.88)"
  },
  fonts: {
    heading: "'Chakra Petch', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_82: {
  id: 82,
  name: "Crimson Lattice",
  colors: {
    background: "#0d0205",
    text: "#FFE8EC",
    accent: "#FF4D6D",
    accentGradient: "linear-gradient(135deg, #FF4D6D, #C9184A, #FF9F1C, #FFBF69)",
    surface: "rgba(255, 77, 109, 0.14)",
    backdropColor: "rgba(25, 5, 10, 0.92)",
    headerBg: "rgba(13, 2, 5, 0.97)",
    tabActiveBg: "rgba(255, 77, 109, 0.21)",
    tabBorder: "#FF4D6D"
  },
  fonts: {
    heading: "'Syne', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_83: {
  id: 83,
  name: "Tangerine Dream",
  colors: {
    background: "#1a0f05",
    text: "#ffedd5",
    accent: "#ff8c42",
    accentGradient: "linear-gradient(135deg, #ff8c42, #ff6b35, #f4442e)",
    surface: "rgba(255, 140, 66, 0.2)",
    backdropColor: "rgba(70, 45, 20, 0.87)"
  },
  fonts: {
    heading: "'Josefin Slab', serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_84: {
  id: 84,
  name: "Midnight Plum",
  colors: {
    background: "#120a14",
    text: "#fae8ff",
    accent: "#a855f7",
    accentGradient: "linear-gradient(45deg, #a855f7, #9333ea, #7e22ce)",
    surface: "rgba(168, 85, 247, 0.18)",
    backdropColor: "rgba(45, 30, 55, 0.89)"
  },
  fonts: {
    heading: "'Cormorant Garamond', serif",
    body: "'Roboto', sans-serif"
  }
},
STYLE_85: {
  id: 85,
  name: "Jungle Green",
  colors: {
    background: "#0a1a0f",
    text: "#bbf7d0",
    accent: "#22c55e",
    accentGradient: "linear-gradient(45deg, #22c55e, #16a34a, #15803d)",
    surface: "rgba(34, 197, 94, 0.15)",
    backdropColor: "rgba(20, 55, 35, 0.88)"
  },
  fonts: {
    heading: "'DM Sans', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_86: {
  id: 86,
  name: "Cherry Pop",
  colors: {
    background: "#1a0510",
    text: "#fce7f3",
    accent: "#f472b6",
    accentGradient: "linear-gradient(45deg, #f472b6, #ec4899, #db2777)",
    surface: "rgba(244, 114, 182, 0.2)",
    backdropColor: "rgba(60, 25, 45, 0.88)"
  },
  fonts: {
    heading: "'Syne', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_87: {
  id: 87,
  name: "Ocean Breeze",
  colors: {
    background: "#051419",
    text: "#cffafe",
    accent: "#22d3ee",
    accentGradient: "linear-gradient(45deg, #22d3ee, #06b6d4, #0891b2)",
    surface: "rgba(34, 211, 238, 0.15)",
    backdropColor: "rgba(15, 50, 70, 0.87)"
  },
  fonts: {
    heading: "'Iceland', cursive",
    body: "'Roboto', sans-serif"
  }
},
STYLE_88: {
  id: 88,
  name: "Golden Hour",
  colors: {
    background: "#1a1205",
    text: "#fef3c7",
    accent: "#fbbf24",
    accentGradient: "linear-gradient(135deg, #fbbf24, #f59e0b, #d97706)",
    surface: "rgba(251, 191, 36, 0.18)",
    backdropColor: "rgba(70, 50, 20, 0.88)"
  },
  fonts: {
    heading: "'Playfair Display', serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_89: {
  id: 89,
  name: "Velvet Purple",
  colors: {
    background: "#0f0a14",
    text: "#f3e8ff",
    accent: "#c084fc",
    accentGradient: "linear-gradient(45deg, #c084fc, #a855f7, #9333ea)",
    surface: "rgba(192, 132, 252, 0.18)",
    backdropColor: "rgba(40, 30, 55, 0.89)"
  },
  fonts: {
    heading: "'Cinzel Decorative', cursive",
    body: "'Inter', sans-serif"
  }
},
STYLE_90: {
  id: 90,
  name: "Tropical Paradise",
  colors: {
    background: "#0a1a14",
    text: "#d1fae5",
    accent: "#10b981",
    accentGradient: "linear-gradient(135deg, #10b981, #059669, #047857)",
    surface: "rgba(16, 185, 129, 0.15)",
    backdropColor: "rgba(20, 55, 40, 0.88)"
  },
  fonts: {
    heading: "'Josefin Sans', sans-serif",
    body: "'Inter', sans-serif"
  }
},
STYLE_91: {
  id: 91,
  name: "Crimson Royale",
  colors: {
    background: "#1A0A0E",
    text: "#F8F8FF",
    accent: "#DC143C",
    accentGradient: "linear-gradient(45deg, #DC143C, #B22222)",
    surface: "rgba(220, 20, 60, 0.2)",
    backdropColor: "rgba(70, 20, 30, 0.89)"
  },
  fonts: {
    heading: "'Cinzel Decorative', cursive",
    body: "'Roboto', sans-serif"
  }
}
};
// Add this function at the end of src/theme/welcomeStyles.js
export const getWelcomeBackground = (themeId) => {
  const backgrounds = {
    // Styles 1-10: Original themes
    1: { type: 'gradient', value: 'linear-gradient(135deg, #0a1929 0%, #1a2942 50%, #0d1b2a 100%)' },
    2: { type: 'gradient', value: 'radial-gradient(circle at 20% 50%, rgba(100, 255, 218, 0.15), transparent 50%), radial-gradient(circle at 80% 50%, rgba(0, 181, 206, 0.1), transparent 50%), #0A192F' },
    3: { type: 'gradient', value: 'linear-gradient(135deg, #1a1506 0%, #2d2208 50%, #1a1506 100%)' },
    4: { type: 'gradient', value: 'radial-gradient(circle at 30% 40%, rgba(66, 211, 146, 0.2), transparent 40%), radial-gradient(circle at 70% 60%, rgba(100, 126, 201, 0.15), transparent 40%), #050B15' },
    5: { type: 'gradient', value: 'linear-gradient(135deg, #1a1128 0%, #2d1838 50%, #1a1128 100%)' },
    6: { type: 'gradient', value: 'radial-gradient(circle at 50% 50%, rgba(16, 185, 129, 0.15), transparent 60%), #111927' },
    7: { type: 'gradient', value: 'linear-gradient(135deg, #13161d 0%, #1f252e 50%, #13161d 100%)' },
    8: { type: 'gradient', value: 'radial-gradient(circle at 50% 100%, rgba(240, 68, 56, 0.25), transparent 50%), #121212' },
    9: { type: 'gradient', value: 'linear-gradient(180deg, #0d1521 0%, #1a2638 50%, #0d1521 100%)' },
    10: { type: 'gradient', value: 'radial-gradient(circle at 20% 30%, rgba(217, 70, 239, 0.3), transparent 40%), radial-gradient(circle at 80% 70%, rgba(147, 51, 234, 0.2), transparent 40%), #0F0F1A' },
    // Styles 11-20: Cultural/Creative themes
    11: { type: 'gradient', value: 'linear-gradient(135deg, #0d0515 0%, #1a0a2e 50%, #2d1458 100%)' },
    12: { type: 'gradient', value: 'linear-gradient(135deg, #0f0805 0%, #1a0f0a 50%, #2d1f14 100%)' },
    13: { type: 'gradient', value: 'linear-gradient(180deg, #121820 0%, #1b2838 50%, #0f1419 100%)' },
    14: { type: 'gradient', value: 'radial-gradient(circle at 30% 30%, rgba(255, 0, 64, 0.3), transparent 50%), radial-gradient(circle at 70% 70%, rgba(255, 107, 53, 0.2), transparent 50%), #1A0B0B' },
    15: { type: 'gradient', value: 'linear-gradient(135deg, #0a1219 0%, #0d1b2a 50%, #1a3a52 100%)' },
    16: { type: 'gradient', value: 'radial-gradient(circle at 50% 20%, rgba(0, 210, 255, 0.2), transparent 50%), radial-gradient(circle at 50% 80%, rgba(108, 92, 231, 0.15), transparent 50%), #0A0E27' },
    17: { type: 'gradient', value: 'linear-gradient(135deg, #050d12 0%, #0d1b2a 50%, #112a3a 100%)' },
    18: { type: 'gradient', value: 'linear-gradient(135deg, #0d0a15 0%, #1a1a2e 50%, #2d2550 100%)' },
    19: { type: 'gradient', value: 'linear-gradient(135deg, #0d0805 0%, #1a1410 50%, #2d2820 100%)' },
    20: { type: 'gradient', value: 'linear-gradient(135deg, #0e0e10 0%, #1c1c1e 50%, #2d2d30 100%)' },
    // Styles 21-30: Tech/Space themes
    21: { type: 'gradient', value: 'radial-gradient(circle at 40% 40%, rgba(247, 147, 26, 0.15), transparent 50%), radial-gradient(circle at 60% 60%, rgba(80, 175, 149, 0.1), transparent 50%), #0B0E11' },
    22: { type: 'gradient', value: 'radial-gradient(circle at 20% 30%, rgba(255, 16, 240, 0.25), transparent 40%), radial-gradient(circle at 80% 70%, rgba(0, 245, 255, 0.2), transparent 40%), #1a0f1f' },
    23: { type: 'gradient', value: 'linear-gradient(135deg, #0f0a05 0%, #1c1410 50%, #2d2315 100%)' },
    24: { type: 'gradient', value: 'radial-gradient(circle at 50% 50%, rgba(255, 0, 255, 0.2), transparent 50%), #0A0A0A' },
    25: { type: 'gradient', value: 'linear-gradient(135deg, #0d0a0d 0%, #1a1a1a 50%, #2d1a2d 100%)' },
    26: { type: 'gradient', value: 'radial-gradient(circle at 30% 40%, rgba(255, 255, 0, 0.15), transparent 40%), radial-gradient(circle at 70% 60%, rgba(255, 0, 255, 0.15), transparent 40%), #0F0F23' },
    27: { type: 'gradient', value: 'radial-gradient(circle at 25% 25%, rgba(0, 255, 65, 0.2), transparent 40%), radial-gradient(circle at 75% 75%, rgba(255, 0, 255, 0.15), transparent 40%), #0a0a0a' },
    28: { type: 'gradient', value: 'radial-gradient(circle at 40% 30%, rgba(183, 148, 246, 0.25), transparent 50%), radial-gradient(circle at 60% 70%, rgba(255, 110, 199, 0.2), transparent 50%), #0a0520' },
    29: { type: 'gradient', value: 'radial-gradient(circle at 50% 30%, rgba(138, 43, 226, 0.3), transparent 50%), radial-gradient(circle at 50% 70%, rgba(218, 112, 214, 0.2), transparent 50%), #1B0A2E' },
    30: { type: 'gradient', value: 'radial-gradient(circle at 50% 50%, rgba(30, 144, 255, 0.2), transparent 60%), #000000' },
    // Styles 31-40
    31: { type: 'gradient', value: 'linear-gradient(135deg, #0a0f0d 0%, #0f1b15 50%, #1a2e20 100%)' },
    32: { type: 'gradient', value: 'linear-gradient(135deg, #0f0a0d 0%, #1f1419 50%, #2f1e26 100%)' },
    33: { type: 'gradient', value: 'linear-gradient(135deg, #070d0d 0%, #0d1a1a 50%, #132727 100%)' },
    34: { type: 'gradient', value: 'linear-gradient(135deg, #0d0a10 0%, #1a1625 50%, #27223a 100%)' },
    35: { type: 'gradient', value: 'radial-gradient(circle at 30% 40%, rgba(167, 139, 250, 0.3), transparent 50%), radial-gradient(circle at 70% 60%, rgba(236, 72, 153, 0.2), transparent 50%), #0a0015' },
    36: { type: 'gradient', value: 'linear-gradient(135deg, #0f0a05 0%, #1f1410 50%, #2f2115 100%)' },
    37: { type: 'gradient', value: 'linear-gradient(135deg, #060a0d 0%, #0c1821 50%, #12293a 100%)' },
    38: { type: 'gradient', value: 'linear-gradient(135deg, #0a0d05 0%, #141a0f 50%, #1f2a15 100%)' },
    39: { type: 'gradient', value: 'linear-gradient(135deg, #0d0505 0%, #1a0f0f 50%, #271515 100%)' },
    40: { type: 'gradient', value: 'linear-gradient(135deg, #0d0d10 0%, #1a1a1f 50%, #27272f 100%)' },
    // Styles 41-50
    41: { type: 'gradient', value: 'linear-gradient(135deg, #050a0d 0%, #0a1a1f 50%, #0f2a38 100%)' },
    42: { type: 'gradient', value: 'linear-gradient(135deg, #0f0d05 0%, #1f1a0a 50%, #2f290f 100%)' },
    43: { type: 'gradient', value: 'linear-gradient(135deg, #0d0a10 0%, #1a141f 50%, #271e2f 100%)' },
    44: { type: 'gradient', value: 'linear-gradient(135deg, #080d0a 0%, #0f1a14 50%, #16271e 100%)' },
    45: { type: 'gradient', value: 'linear-gradient(135deg, #080a0d 0%, #0f1419 50%, #161f26 100%)' },
    46: { type: 'gradient', value: 'linear-gradient(135deg, #10050f 0%, #1f0a1f 50%, #2f0f2f 100%)' },
    47: { type: 'gradient', value: 'linear-gradient(135deg, #0a0a0d 0%, #141419 50%, #1f1f26 100%)' },
    48: { type: 'gradient', value: 'linear-gradient(135deg, #050f0d 0%, #0a1f1a 50%, #0f2f27 100%)' },
    49: { type: 'gradient', value: 'linear-gradient(135deg, #0f0a05 0%, #1f140a 50%, #2f1f0f 100%)' },
    50: { type: 'gradient', value: 'linear-gradient(135deg, #0a0a10 0%, #14141f 50%, #1f1f2f 100%)' },
    // Styles 51-60
    51: { type: 'gradient', value: 'radial-gradient(circle at 40% 30%, rgba(79, 209, 197, 0.25), transparent 50%), radial-gradient(circle at 60% 70%, rgba(102, 126, 234, 0.2), transparent 50%), #000510' },
    52: { type: 'gradient', value: 'linear-gradient(135deg, #050f0f 0%, #0a1f1f 50%, #0f2f2f 100%)' },
    53: { type: 'gradient', value: 'linear-gradient(135deg, #0f0a05 0%, #1f1410 50%, #2f1f15 100%)' },
    54: { type: 'gradient', value: 'radial-gradient(circle at 25% 35%, rgba(255, 56, 100, 0.3), transparent 45%), radial-gradient(circle at 75% 65%, rgba(139, 0, 255, 0.2), transparent 45%), #1a0808' },
    55: { type: 'gradient', value: 'linear-gradient(135deg, #05080f 0%, #0a0f1f 50%, #0f162f 100%)' },
    56: { type: 'gradient', value: 'linear-gradient(135deg, #0d0a0d 0%, #1a141a 50%, #271e27 100%)' },
    57: { type: 'gradient', value: 'linear-gradient(135deg, #0a0d05 0%, #141a0f 50%, #1f2715 100%)' },
    58: { type: 'gradient', value: 'linear-gradient(135deg, #0f0505 0%, #1f0a0a 50%, #2f0f0f 100%)' },
    59: { type: 'gradient', value: 'linear-gradient(135deg, #050a0d 0%, #0a1419 50%, #0f1f26 100%)' },
    60: { type: 'gradient', value: 'linear-gradient(135deg, #0d0a05 0%, #1a140a 50%, #271f0f 100%)' }
  };
  return backgrounds[themeId] || { type: 'solid', value: '#000000' };
};
export const getComplementaryHeaderTheme = (mainTheme) => {
  const complementaryMappings = {
    // Style 1: Carbon Fiber -> Electric Blue Header
    1: {
      background: "rgba(0, 30, 60, 0.95)",
      accent: "#00D4FF",
      gradient: "linear-gradient(135deg, rgba(0, 30, 60, 0.9), rgba(0, 100, 150, 0.7))",
      border: "rgba(0, 212, 255, 0.3)"
    },
    
    // Style 2: Cosmic Blue -> Deep Purple Header  
    2: {
      background: "rgba(30, 0, 60, 0.95)",
      accent: "#B388FF",
      gradient: "linear-gradient(135deg, rgba(30, 0, 60, 0.9), rgba(60, 20, 100, 0.7))",
      border: "rgba(179, 136, 255, 0.3)"
    },
    // Style 3: Royal Gold -> Deep Burgundy Header
    3: {
      background: "rgba(40, 0, 20, 0.95)",
      accent: "#FFB347",
      gradient: "linear-gradient(135deg, rgba(40, 0, 20, 0.9), rgba(80, 20, 40, 0.7))",
      border: "rgba(255, 179, 71, 0.3)"
    },
    // Style 4: Neon Pulse -> Dark Teal Header
    4: {
      background: "rgba(0, 40, 40, 0.95)",
      accent: "#00FFCC",
      gradient: "linear-gradient(135deg, rgba(0, 40, 40, 0.9), rgba(20, 80, 80, 0.7))",
      border: "rgba(0, 255, 204, 0.3)"
    },
    // Style 5: Sunset Horizon -> Deep Ocean Header
    5: {
      background: "rgba(10, 30, 60, 0.95)",
      accent: "#FF6B9D",
      gradient: "linear-gradient(135deg, rgba(10, 30, 60, 0.9), rgba(30, 60, 100, 0.7))",
      border: "rgba(255, 107, 157, 0.3)"
    },
    // Style 6: Emerald Forest -> Mountain Purple Header
    6: {
      background: "rgba(40, 20, 60, 0.95)",
      accent: "#7FFF7F",
      gradient: "linear-gradient(135deg, rgba(40, 20, 60, 0.9), rgba(80, 40, 100, 0.7))",
      border: "rgba(127, 255, 127, 0.3)"
    },
    // Style 7: Amethyst Glow -> Forest Green Header
    7: {
      background: "rgba(20, 40, 20, 0.95)",
      accent: "#DA70D6",
      gradient: "linear-gradient(135deg, rgba(20, 40, 20, 0.9), rgba(40, 80, 40, 0.7))",
      border: "rgba(218, 112, 214, 0.3)"
    },
    // Style 8: Obsidian Volcanic -> Cool Steel Header
    8: {
      background: "rgba(30, 40, 50, 0.95)",
      accent: "#FF7F50",
      gradient: "linear-gradient(135deg, rgba(30, 40, 50, 0.9), rgba(60, 80, 100, 0.7))",
      border: "rgba(255, 127, 80, 0.3)"
    },
    // Style 9: Arctic Frost -> Warm Amber Header
    9: {
      background: "rgba(60, 40, 20, 0.95)",
      accent: "#87CEEB",
      gradient: "linear-gradient(135deg, rgba(60, 40, 20, 0.9), rgba(100, 80, 40, 0.7))",
      border: "rgba(135, 206, 235, 0.3)"
    },
    // Style 10: Ethereal Nebula -> Sunset Orange Header
    10: {
      background: "rgba(60, 30, 0, 0.95)",
      accent: "#FF6347",
      gradient: "linear-gradient(135deg, rgba(60, 30, 0, 0.9), rgba(100, 60, 20, 0.7))",
      border: "rgba(255, 99, 71, 0.3)"
    },
    // Style 11: Pitch Perfect -> Stadium Lights Header
    11: {
      background: "rgba(0, 25, 50, 0.95)",
      accent: "#FFFF00",
      gradient: "linear-gradient(135deg, rgba(0, 25, 50, 0.9), rgba(20, 50, 80, 0.7))",
      border: "rgba(255, 255, 0, 0.4)"
    },
    // Style 12: Highland Coffee -> Morning Sky Header
    12: {
      background: "rgba(30, 50, 70, 0.95)",
      accent: "#FFA500",
      gradient: "linear-gradient(135deg, rgba(30, 50, 70, 0.9), rgba(60, 90, 120, 0.7))",
      border: "rgba(255, 165, 0, 0.3)"
    },
    // Style 13: Desert Rose -> Oasis Blue Header
    13: {
      background: "rgba(10, 40, 60, 0.95)",
      accent: "#40E0D0",
      gradient: "linear-gradient(135deg, rgba(10, 40, 60, 0.9), rgba(30, 80, 100, 0.7))",
      border: "rgba(64, 224, 208, 0.3)"
    },
    // Style 14: Street Art -> Urban Night Header
    14: {
      background: "rgba(20, 20, 40, 0.95)",
      accent: "#FF1493",
      gradient: "linear-gradient(135deg, rgba(20, 20, 40, 0.9), rgba(40, 40, 80, 0.7))",
      border: "rgba(255, 20, 147, 0.4)"
    },
    // Style 15: Stars & Stripes -> Liberty Blue Header
    15: {
      background: "rgba(10, 30, 70, 0.95)",
      accent: "#FFD700",
      gradient: "linear-gradient(135deg, rgba(10, 30, 70, 0.9), rgba(30, 60, 120, 0.7))",
      border: "rgba(255, 215, 0, 0.4)"
    },
    // Continue for remaining styles 16-30...
    16: {
      background: "rgba(40, 20, 60, 0.95)",
      accent: "#00CED1",
      gradient: "linear-gradient(135deg, rgba(40, 20, 60, 0.9), rgba(80, 40, 100, 0.7))",
      border: "rgba(0, 206, 209, 0.3)"
    },
    17: {
      background: "rgba(60, 0, 60, 0.95)",
      accent: "#7FFF00",
      gradient: "linear-gradient(135deg, rgba(60, 0, 60, 0.9), rgba(100, 20, 100, 0.7))",
      border: "rgba(127, 255, 0, 0.4)"
    },
    18: {
      background: "rgba(40, 40, 0, 0.95)",
      accent: "#DDA0DD",
      gradient: "linear-gradient(135deg, rgba(40, 40, 0, 0.9), rgba(80, 80, 20, 0.7))",
      border: "rgba(221, 160, 221, 0.3)"
    },
    19: {
      background: "rgba(0, 40, 40, 0.95)",
      accent: "#FF6347",
      gradient: "linear-gradient(135deg, rgba(0, 40, 40, 0.9), rgba(20, 80, 80, 0.7))",
      border: "rgba(255, 99, 71, 0.4)"
    },
    20: {
      background: "rgba(60, 20, 0, 0.95)",
      accent: "#00BFFF",
      gradient: "linear-gradient(135deg, rgba(60, 20, 0, 0.9), rgba(100, 40, 20, 0.7))",
      border: "rgba(0, 191, 255, 0.3)"
    },
    21: {
      background: "rgba(20, 60, 20, 0.95)",
      accent: "#FFB347",
      gradient: "linear-gradient(135deg, rgba(20, 60, 20, 0.9), rgba(40, 100, 40, 0.7))",
      border: "rgba(255, 179, 71, 0.4)"
    },
    22: {
      background: "rgba(60, 40, 80, 0.95)",
      accent: "#F4A460",
      gradient: "linear-gradient(135deg, rgba(60, 40, 80, 0.9), rgba(100, 80, 120, 0.7))",
      border: "rgba(244, 164, 96, 0.3)"
    },
    23: {
      background: "rgba(80, 20, 20, 0.95)",
      accent: "#87CEFA",
      gradient: "linear-gradient(135deg, rgba(80, 20, 20, 0.9), rgba(120, 40, 40, 0.7))",
      border: "rgba(135, 206, 250, 0.3)"
    },
    24: {
      background: "rgba(0, 60, 60, 0.95)",
      accent: "#FF69B4",
      gradient: "linear-gradient(135deg, rgba(0, 60, 60, 0.9), rgba(20, 100, 100, 0.7))",
      border: "rgba(255, 105, 180, 0.4)"
    },
    25: {
      background: "rgba(60, 60, 20, 0.95)",
      accent: "#FF1493",
      gradient: "linear-gradient(135deg, rgba(60, 60, 20, 0.9), rgba(100, 100, 40, 0.7))",
      border: "rgba(255, 20, 147, 0.3)"
    },
    26: {
      background: "rgba(80, 40, 0, 0.95)",
      accent: "#00FFFF",
      gradient: "linear-gradient(135deg, rgba(80, 40, 0, 0.9), rgba(120, 80, 20, 0.7))",
      border: "rgba(0, 255, 255, 0.4)"
    },
    27: {
      background: "rgba(0, 50, 80, 0.95)",
      accent: "#FFA07A",
      gradient: "linear-gradient(135deg, rgba(0, 50, 80, 0.9), rgba(20, 90, 120, 0.7))",
      border: "rgba(255, 160, 122, 0.3)"
    },
    28: {
      background: "rgba(80, 80, 0, 0.95)",
      accent: "#FF00FF",
      gradient: "linear-gradient(135deg, rgba(80, 80, 0, 0.9), rgba(120, 120, 20, 0.7))",
      border: "rgba(255, 0, 255, 0.4)"
    },
    29: {
      background: "rgba(60, 80, 40, 0.95)",
      accent: "#DA70D6",
      gradient: "linear-gradient(135deg, rgba(60, 80, 40, 0.9), rgba(100, 120, 80, 0.7))",
      border: "rgba(218, 112, 214, 0.3)"
    },
    30: {
      background: "rgba(40, 0, 80, 0.95)",
      accent: "#FFD700",
      gradient: "linear-gradient(135deg, rgba(40, 0, 80, 0.9), rgba(80, 20, 120, 0.7))",
      border: "rgba(255, 215, 0, 0.4)"
    }
  };
  return complementaryMappings[mainTheme.id] || {
    background: "rgba(30, 30, 30, 0.95)",
    accent: mainTheme.colors.accent,
    gradient: `linear-gradient(135deg, rgba(30, 30, 30, 0.9), rgba(50, 50, 50, 0.7))`,
    border: `${mainTheme.colors.accent}30`
  };
};
// Enhanced responsive sizing system
export const getResponsiveSizes = (screenWidth) => {
  if (screenWidth >= 1920) {
    // 4K+ screens
    return {
      welcomeTitle: "5rem",
      welcomeSubtitle: "1.4rem",
      profileImage: "240px",
      shopName: "6rem",
      headerHeight: "90px",
      logoSize: "2.2rem",
      padding: "3rem",
      cardSize: "320px",
      gridGap: "2.5rem"
    };
  } else if (screenWidth >= 1440) {
    // Large desktop
    return {
      welcomeTitle: "4.5rem",
      welcomeSubtitle: "1.3rem", 
      profileImage: "200px",
      shopName: "5.4rem",
      headerHeight: "80px",
      logoSize: "2rem",
      padding: "2rem",
      cardSize: "280px",
      gridGap: "2rem"
    };
  } else if (screenWidth >= 1024) {
    // Desktop
    return {
      welcomeTitle: "4rem",
      welcomeSubtitle: "1.2rem",
      profileImage: "180px",
      shopName: "4.8rem",
      headerHeight: "75px",
      logoSize: "1.8rem",
      padding: "2rem",
      cardSize: "250px",
      gridGap: "1.5rem"
    };
  } else if (screenWidth >= 768) {
    // Tablet
    return {
      welcomeTitle: "3.5rem",
      welcomeSubtitle: "1.1rem",
      profileImage: "160px",
      shopName: "4rem",
      headerHeight: "70px",
      logoSize: "1.6rem",
      padding: "1.5rem",
      cardSize: "220px",
      gridGap: "1.25rem"
    };
  } else if (screenWidth >= 480) {
    // Large mobile
    return {
      welcomeTitle: "2.8rem",
      welcomeSubtitle: "1rem",
      profileImage: "140px",
      shopName: "3.2rem",
      headerHeight: "65px",
      logoSize: "1.4rem",
      padding: "1rem",
      cardSize: "180px",
      gridGap: "1rem"
    };
  } else {
    // Small mobile
    return {
      welcomeTitle: "2.2rem",
      welcomeSubtitle: "0.9rem",
      profileImage: "120px",
      shopName: "2.5rem",
      headerHeight: "60px",
      logoSize: "1.2rem",
      padding: "1rem",
      cardSize: "160px",
      gridGap: "0.75rem"
    };
  }
};
